import { useTranslation } from 'react-i18next';

export const useTranslationDir = () => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const dir = isRTL ? 'rtl' : 'ltr';

  return { isRTL, dir };
};
